import { render, staticRenderFns } from "./DigitalMarketing.vue?vue&type=template&id=22ae7a9e&"
import script from "./DigitalMarketing.vue?vue&type=script&lang=js&"
export * from "./DigitalMarketing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports